import Button from '@hellodarwin/core/lib/components/common/button';
import { ArrowContainer } from '@hellodarwin/core/lib/components/common/button/arrow/styles';
import styled, { css } from 'styled-components';
export const CardButton = styled(Button) `
  width: 32px;
  height: 32px;
`;
const CardHoverStyled = css `
  cursor: pointer;
  transform: scale(1.01);
  box-shadow:
    0 1px 2px -2px rgba(0, 0, 0, 0.16),
    0 3px 6px 0 rgba(0, 0, 0, 0.12),
    0 5px 12px 4px rgba(0, 0, 0, 0.09);
  ${CardButton} {
    width: 45px;
  }
  ${ArrowContainer} {
    width: 30px;
  }
`;
export const CardStyled = styled.div `
  border-radius: 0px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  background-color: ${({ $backgroundColor, theme }) => !!$backgroundColor ? $backgroundColor : theme.colors.white_1};

  &:hover {
    ${({ $hoverable }) => ($hoverable ? CardHoverStyled : undefined)}
  }
`;
